import { Locale, MarketApiResponse } from "src/model/shop.model";
import {
  APP_DEFAULT_LANGUAGE,
  APP_DEFAULT_LENGUAGE_ID,
  APP_DEFAULT_MARKET_ID,
} from "./constants";
import { ISOCODEHandler, getCurrentCountry } from "./BasePathTools";

export function getMarketId(market: MarketApiResponse ): number {
  return market?.resellStoreId ? Number(market.resellStoreId) : APP_DEFAULT_MARKET_ID;
}

export function getCurrentAvailableLanguage(market) {
  const hasLanguage = location ? !!location.pathname.match(/^\/.*\/.*\/preowned-resell/gm): null;
  const parcialPathLanguage = hasLanguage ? location.pathname.match(/\/([^/]+)\/preowned-resell/)[1] : APP_DEFAULT_LANGUAGE.toLowerCase();

  return market?.languages?.availableLanguages?.find((availableLanguage) => availableLanguage?.code.toLowerCase() === parcialPathLanguage.toLocaleLowerCase())
}

export function getCurrentLanguage(market): string {
  const currentPathLanguage = getCurrentAvailableLanguage(market)
  
  return currentPathLanguage?.code ?? market?.languages?.default?.toLowerCase();
}

export function getCurrentLocale(market: MarketApiResponse): Locale {
  if (Array.isArray(market?.locale)) {
    const currentLocale =  market?.locale?.find(
      (locale: Locale) =>
        locale?.defaultLocale === ISOCODEHandler(getCurrentCountry())?.toUpperCase()
    );
    return currentLocale || market?.locale[0]
  } else {
    return market?.locale;
  }
}

export function getCurrentLanguageId(market: MarketApiResponse): number {
  const language = getCurrentLanguage(market);
  let languageId;
  if (language === APP_DEFAULT_LANGUAGE) {
    languageId = APP_DEFAULT_LENGUAGE_ID;
  } else {
    const currentLanguageObject = market?.languages?.availableLanguages?.find(
      (item) => item?.code === language
    );
    languageId = currentLanguageObject
      ? currentLanguageObject.id
      : APP_DEFAULT_LENGUAGE_ID;
  }
  return languageId;
}
